import { stringify } from 'qs';

// @see https://stackoverflow.com/a/34773221
const hasExtension = (url: string) =>
  url.match(/\[\.#]([0-9a-z]+)(?=[?#])|([.#])(?:[\w]+)$/gi);

const addTrailingSlash = (url: string) => url.replace(/\/$|$/, '/');

const isTruthy = (i: string | null | undefined): i is string => Boolean(i);

const isNotHomepage = (segment: string) => !segment.match(/^\/?home/i);

const stripSlashes = (segment: string, index: number) => {
  if (index === 0) {
    return segment.replace(/^\/{2,}/g, '/').replace(/\/+$/g, '');
  }

  return segment.replace(/^\/+|\/+$/g, '');
};

export const buildUrl = (
  segments: Array<string | null | undefined>,
  query?: Parameters<typeof stringify>[0],
  queryOptions?: Parameters<typeof stringify>[1],
) => {
  const sanitizedUrl = segments
    .filter(isTruthy)
    .map(stripSlashes)
    .filter(isNotHomepage)
    .join('/');

  const [url, queryFromUrl] = sanitizedUrl.split('?');

  const queryString = stringify(query, {
    skipNulls: true,
    ...(queryOptions || {}),
  });

  return [
    hasExtension(url) ? url : addTrailingSlash(url),
    queryString || queryFromUrl,
  ]
    .filter(isTruthy)
    .join('?');
};
